module.exports = __webpack_public_path__ + "static/media/1.d5210d5e.jpg";